module.exports = __webpack_public_path__ + "static/desktop-blog-36cbc4315ce687032b2dbe79fbd9dee3.jpg";